import * as React from "react"

import SimpleModal from "@/shadcn/components/SimpleModal"
import { Button } from "@/shadcn/components/ui/button"
import { BlockerList } from "./ChangeSummary"

/**
 * A move to a smaller plan that the account's current usage won't fit. Figma:
 * S311lGXE6JSyTnNAXHmtR7, "Downgrade / Smaller plan, over limits" (30263:7524).
 *
 * The safe way on is the primary: go and choose what stays on, then come back.
 * Turning everything off to switch today is set apart, smaller and destructive.
 */

type DowngradeBlockedDialogProps = {
  /** The smaller plan's name without "dlvr.it", e.g. "Basic". */
  label: string
  /** One sentence for each thing the smaller plan can't keep running. */
  blockers: string[]
  busy: boolean
  onChooseWhatToKeep: () => void
  onTurnOffAll: () => void
  onClose: () => void
}

export default function DowngradeBlockedDialog({
  label,
  blockers,
  busy,
  onChooseWhatToKeep,
  onTurnOffAll,
  onClose,
}: DowngradeBlockedDialogProps) {
  return (
    <SimpleModal
      title={`Switch to ${label}?`}
      description={`${label} can't run everything you have on right now. Choose what to keep before you switch.`}
      confirmLabel="Choose what to keep"
      onConfirm={onChooseWhatToKeep}
      onClose={onClose}
    >
      <BlockerList heading={`Over ${label}'s limits`} items={blockers} />
      <div className="tw:flex tw:items-center tw:gap-3">
        <p className="tw:min-w-0 tw:flex-1 tw:text-xs tw:text-muted-foreground">
          Or turn everything off now and switch today.
        </p>
        <Button variant="destructive" size="sm" loading={busy} onClick={onTurnOffAll}>
          Turn off all
        </Button>
      </div>
    </SimpleModal>
  )
}
